import { VipPassForm } from './VipPassForm';
export default VipPassForm;
